export default __webpack_public_path__ + "media/images/images/icons/sketch-c041c8f9dbbc42eee5bfd0fb3f3e0c61.png";